import { useEffect, useState } from 'react';

/** Khổ ≥ 1800: bảng phải 372 mở sẵn (Mint-*-1920). */
export function useWide() {
  const q = '(min-width: 1800px)';
  const [w, setW] = useState(() => typeof window !== 'undefined' && window.matchMedia(q).matches);
  useEffect(() => {
    const m = window.matchMedia(q);
    const on = () => setW(m.matches);
    m.addEventListener('change', on);
    return () => m.removeEventListener('change', on);
  }, []);
  return w;
}
